<template>
    <div>
        <!-- List header -->
        <a-row type="flex" :gutter="24">
            <!-- <a-col :span="12" class="mb-24">
                <a-date-picker allowClear
                                @change="handleDateChanged"
                />
			</a-col> -->
            <a-col :span="12" class="mb-24">
                <a-select @select="handleRestaurantOptionSelect">
                    <template v-for="r in restaurants">
                        <a-select-option :key="r.restaurantId">
                            {{r.restaurantName}}
                        </a-select-option>
                    </template>
                </a-select>
            </a-col>
            <a-col :span="12" class="mb-24 text-right">
                <!-- <a-button @click="openAddNewOrderModal" class="ml-15">
					<i class="ni ni-archive-2 mr-5"></i> ADD ORDER
				</a-button> -->
                <a-button @click="openSendMessageModal" class="ml-15">
					<i class="ni ni-archive-2 mr-5"></i> SEND MESSAGE
				</a-button>
                <a-button @click="openSelectRestaurantModal" class="ml-15">
					<i class="ni ni-archive-2 mr-5"></i> ADD ORDER
				</a-button>
            </a-col>
        </a-row>
        <!-- / List header -->

        <!-- List card -->
        <a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">
            
            <orders-list-view ref="ordersListRef"/>
        </a-card>
        <!-- / List card -->

        <add-new-order-modal ref="addNewOrderRef"/>
        <select-restaurant-modal ref="selectRestaurantRef" @selectedRestaurant="handleSelectedRestaurantEvent"/>
        <send-message-modal ref="sendMessageRef"/>
    </div> 
</template>

<script>
import AddNewOrderModal from './AddNewOrderViewModal.vue'
import OrdersListView from './OrdersListView.vue'
import SelectRestaurantModal from './SelectRestaurantViewModal.vue'
import SendMessageModal from './SendMessageModal.vue'
import moment from 'moment'
import { mapState } from 'vuex'
export default {

    components : {
        AddNewOrderModal,
        OrdersListView,
        SelectRestaurantModal,
        SendMessageModal
    },
    computed : {
        ...mapState({
            restaurants : state => state.phoneService.restaurants
        })
    },
    data() {
        return {
            selectedRestaurant : null
        }
    },
    methods : {
        openAddNewOrderModal() {
            this.$refs['addNewOrderRef'].showModal();
        },

        openSelectRestaurantModal() {
            this.$refs['selectRestaurantRef'].showModal(); 
        },

        openSendMessageModal() {
            this.$refs['sendMessageRef'].showModal(); 
        },

        async handleRestaurantOptionSelect(e) {
            this.$message.loading('Loading data...', 0);
            await this.$store.dispatch('phoneService/getCurrentOrdersAction', {'restaurantId' : e});
            this.$message.destroy();
        },
        
        async handleSelectedRestaurantEvent(e) {
            this.$message.loading('Loading data...', 0);
            console.log(e)
            this.$store.commit('phoneService/SET_SELECTED_RESTAURANT_ID_STATE', e);
            this.$refs['addNewOrderRef'].showModal();
            //this.$message.destroy();
        },

        // async handleDateChanged(selectedDate) {
        //     console.log(selectedDate.format("DDMMyyyy"));
        //     this.$message.loading('Updating data...', 0);
        //     await this.$store.dispatch('orders/getOrdersByDateAndRestaurantAction', { 'createdDate' : selectedDate.format("DDMMyyyy")});
            
        //     await this.sleep(2000);
        //     this.$message.destroy();

        // },

        async sleep(miliSeconds) {
            return new Promise(r => setTimeout(r, miliSeconds));
        },
    },

    async created() {
        this.$message.loading('Loading data...', 0);
        await this.$store.dispatch('phoneService/getAllRestaurantsAction', {});
        await this.sleep(2000);
        this.$message.destroy();
    }
}
</script>

<style>

</style>